/** Блок условий поставки в конце full_description (выделяется отдельно на странице решения). */
export const PRODUCT_VENDOR_TERMS_MARKER =
  'Мы работаем с вендорами по официальным договорам, цена на сайте указана РРЦ (рекомендуемая розничная цена вендора).';

export const PRODUCT_VENDOR_TERMS_TAIL =
  'Нашим клиентам окажем услуги по подбору, покупке и продлению лицензий.';

/** Шаблонные строки в начале full_description, которые не показываем. */
const PRODUCT_DESCRIPTION_BOILERPLATE_LINES = [
  /^.+ — решение вендора .+\.\s*$/i,
  /^.+ от .+ - лицензии для B2B,?\s*подбор через Антологию\.?\s*$/i,
  /^.+ входит в продуктовую линейку .+ и поставляется для корпоративного использования\.\s*$/i,
  /^.+ - импортозамещение \(.+\)\s*$/i,
];

/**
 * Убирает шаблонные абзацы из подробного описания решения.
 * @param {string} rawDescription
 * @returns {string}
 */
export function stripProductDescriptionBoilerplate(rawDescription) {
  const raw = (rawDescription || '').trim();
  if (!raw) return '';

  const paragraphs = raw.split(/\n\s*\n/);
  const kept = paragraphs
    .map((p) => p.trim())
    .filter(Boolean)
    .filter(
      (paragraph) =>
        !PRODUCT_DESCRIPTION_BOILERPLATE_LINES.some((pattern) => pattern.test(paragraph)),
    );

  return kept.join('\n\n').trim();
}

function escapePlainTextToHtml(raw) {
  return raw
    .split('\n')
    .map((line) => line.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'))
    .join('<br/>');
}

function toHtml(raw) {
  if (!raw) return '';
  const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(raw);
  if (hasHtmlTags) return raw;
  return escapePlainTextToHtml(raw);
}

/**
 * Отделяет хвост про договоры/РРЦ от основного описания.
 * @returns {{ mainHtml: string, termsHtml: string | null }}
 */
export function splitProductDescription(rawDescription) {
  const raw = stripProductDescriptionBoilerplate(rawDescription);
  if (!raw) return { mainHtml: '', termsHtml: null };

  const markerIndex = raw.indexOf(PRODUCT_VENDOR_TERMS_MARKER);
  if (markerIndex < 0) {
    return { mainHtml: toHtml(raw), termsHtml: null };
  }

  let main = raw.slice(0, markerIndex).trim();
  main = main.replace(/(?:<br\s*\/?>|\s)+$/i, '').trim();

  let terms = raw.slice(markerIndex).trim();
  terms = terms.replace(/^(?:<br\s*\/?>)+/i, '').trim();

  return {
    mainHtml: toHtml(main),
    termsHtml: toHtml(terms),
  };
}
